import { atom } from 'recoil';

export const settingsTabStateAtom = atom({
  key: 'settingsTabState',
  default: 'General'
});


export const userPinterestStateAtom = atom({
  key: 'userPinterestState',
  default: []
});

export const userInstagramStateAtom = atom({
  key: 'userInstagramState',
  default: []
});